module.exports = __webpack_public_path__ + "static/delay-450b298c56338a544ca1d6b63e2587d3.mp4";